export default __webpack_public_path__ + "static/media/icon-audiodescricao.fc2ec9d7.svg";